export default {
  variables: {
    add_package: 'Thêm gói',
    update_package: 'Cập nhật gói',
    delete_package: 'Xóa gói',
    add_package_category: 'Thêm danh mục gói',
    update_package_category: 'Cập nhật danh mục gói',
    delete_package_category: 'Xóa danh mục gói',
    add_package_group: 'Thêm nhóm gói',
    update_package_group: 'Cập nhật nhóm gói',
    delete_package_group: 'Xóa nhóm gói',
    add_package_detail: 'Thêm chi tiết gói',
    update_package_detail: 'Cập nhật chi tiết gói',
    delete_package_detail: 'Xóa chi tiết gói',
    package_start_date: 'Ngày bắt đầu',
    package_end_date: 'Ngày kết thúc',
    package_code: 'Mã gói',
    package_sold_individually: 'Sửa cho phép bán riêng gói',
    package_display_price: 'Hiển thị giá gói',
    package_tax_fee: 'Gói bao gồm thuế',
    package_transaction: 'Giao dịch gói',
    package_frequency_use: 'Tần suất sử dụng gói',
    package_stop_selling: 'Gói ngừng bán',
    package_description: 'Mô tả gói',
    package_name: 'Tên gói',
    package_package_category: 'Danh mục gói',
    package_price: 'Giá gói',
    package_billing_rule: 'Quy tắc tính tiền gói',
    package_group_code: 'Mã nhóm gói',
    package_group_name: 'Tên nhóm gói',
    package_group_description: 'Mô tả nhóm gói',
    package_group_sold_individually: 'Cho phép bán riêng nhóm gói',
    package_group_stop_selling: 'Ngừng bán nhóm gói',
    package_group_active: 'Nhóm gói hoạt động',
    package_group_packages: 'Danh sách gói trong nhóm gói',
    package_active: 'Gói hoạt động',
    package_currency: 'Tiền tệ của gói',
    package_category_code: 'Mã danh mục gói',
    package_category_description: 'Mô tả danh mục gói',
    package_category_active: 'Danh mục gói hoạt động',
    mon: 'Thứ hai',
    tue: 'Thứ ba',
    wed: 'Thứ tư',
    thu: 'Thứ năm',
    fri: 'Thứ sáu',
    sat: 'Thứ bảy',
    sun: 'Chủ nhật',
    package_detail_effective_date: 'Ngày có hiệu lực của chi tiết gói',
    package_detail_expiration_date: 'Ngày hết hiệu lực của chi tiết gói',
    package_detail_unit_price: 'Đơn giá của chi tiết gói',
    package_detail_applicable_day: 'Ngày áp dụng của chi tiết gói',
    non: 'Không có',
    all: 'Tất cả',
    package_detail_max_people_apply:
      'Số lượng người áp dụng tối đa của chi tiết gói',
    package_detail_min_people_apply:
      'Số lượng người áp dụng tối thiểu của chi tiết gói',
    package_detail_num_people_apply: 'Số lượng người áp dụng của chi tiết gói',
    package_detail_not_apply: 'Không áp dụng',
    package_detail_apply: 'Áp dụng',
    package_detail_num_night_apply: 'Số lượng đêm áp dụng của chi tiết gói',
    package_detail_min_night_apply:
      'Số lượng đêm áp dụng tối thiểu của chi tiết gói',
    package_detail_max_night_apply:
      'Số lượng đêm áp dụng tối đa của chi tiết gói',

    // 'package_description': 'Mô tả',
    true: 'Có',
    false: 'Không',
    noData: 'không có dữ liệu',
    noChild: '',
    search: 'Tìm kiếm',
    monday: 'Thứ hai',
    tuesday: 'Thứ ba',
    wednesday: 'Thứ tư',
    thursday: 'Thứ năm',
    friday: 'Thứ sáu',
    saturday: 'Thứ bảy',
    sunday: 'Chủ nhật',
    min: 'Tối thiểu',
    max: 'Tối đa',
    packageCategory: 'Danh mục gói',
    packageGroup: 'Nhóm gói',
    package: 'Gói',
    packageDetail: 'Chi tiết gói',
    add: 'Thêm',
    edit: 'Sửa',
    delete: 'Xóa',
    stopSelling: 'Ngừng bán',
    total: 'Tổng cộng',
    newRequest: 'Yêu cầu mới',
    received: 'Đã tiếp nhận',
    rejected: 'Đã từ chối',
    completed: 'Đã hoàn thành',
    cash: 'Tiền mặt',
    debt: 'Công nợ',
    creditCard: 'Thẻ tín dụng',
    bankTransfer: 'Chuyển khoản',
    debitCard: 'Thẻ trả trước',
    other: 'Khác',
    active: 'Hoạt động',
    nonActive: 'Không hoạt động',
    segment: 'Segment',
    agency: 'Đại lý',
    percentage: 'Phần trăm',
    amountOfMoney: 'Số tiền',
    limited: 'Giới hạn',
    unlimited: 'Không giới hạn',
    receptionist: 'Lễ tân',
    ticket: 'Vé',
    // surplus: 'Số dư',
    applying: 'Đang áp dụng',
    stopApplying: 'Ngừng áp dụng',
    checkInEarly: 'Nhận phòng sớm',
    checkOutLate: 'Trả phòng muộn',
    totalNumOfGuest: 'Tổng số khách',
    totalRevenue: 'Tổng số doanh thu',
    totalNumOfRoom: 'Tổng số phòng',
    select: 'Chọn',
    OTHER: 'Khác',
    PREPAID_CARD_PAYMENT: 'Thẻ trả trước',
    //
    CREDIT_CARD_PAYMENT: 'Thẻ tín dụng',
    CREDIT_DEPOSIT: 'Thẻ tín dụng',
    CREDIT_REFUND: 'Thẻ tín dụng',
    //
    TRANSFER_PAYMENT: 'Chuyển khoản',
    TRANSFER_DEPOSIT: 'Chuyển khoản',
    TRANSFER_REFUND: 'Chuyển khoản',
    //
    DEBT_PAYMENT_HOTEL: 'Công nợ',
    //
    CASH_PAYMENT: 'Tiền mặt',
    CASH_DEPOSIT: 'Tiền mặt',
    CASH_REFUND: 'Tiền mặt'
  }
}
